<template>
  <div class="d-flex checkin-status-select">
    <div
      v-for="(item, index) in items"
      :key="index"
      class="text-center widget-item"
      :class="{ selected: value === item.value }"
      @click="$emit('input', item.value)"
    >
      <div class="d-flex justify-content-center">
        <div class="circle variant" :data-variant="getVariant(item)" data-apply-border-color>
          <span class="pill variant" :data-variant="getVariant(item)" data-apply-bg-color></span>
        </div>
      </div>
      <div v-if="!hideLabel" class="pt-1 label">{{ item.label }}</div>
    </div>
  </div>
</template>

<script>
import { VARIANT_MAP } from '@/constants/common'

/**
 * This component can be used to select KR status while checking-in
 *
 * props:
 *   - items: Array of {label, value}
 *   - v-model
 *   - value: String
 *      (Generally value is not required if you are using v-model)
 * emits:
 *   - @input: (value) => {}
 *      (Generally @input is not required if you are using v-model)
 */
export default {
  name: 'CheckinStatusSelect',
  props: ['items', 'value', 'hideLabel'],
  methods: {
    getVariant({ type }) {
      return VARIANT_MAP['status-' + type]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';
@import '~@/styles/goals';

.checkin-status-select .widget-item {
  cursor: pointer;

  &:not(:last-child) {
    padding-right: 1rem;
  }

  .label {
    white-space: nowrap;
    color: #c4c4c4;
    transition: all ease-in 200ms;
  }

  .circle {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    position: relative;

    .pill {
      width: 7px;
      height: 7px;
      border-radius: 50%;
      display: block;
      transition: all ease-in 200ms;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%, -50%, 0);
    }
  }

  &.selected {
    .pill {
      height: 15px;
      width: 15px;
    }

    .label {
      color: #4d4d4d;
    }
  }
}
.circle {
  border: 1px solid $borderPrimary;
}
</style>
